export { EmojiVirtualScrollData, EmojiListNavigationKeys, EmojiItem } from './lib/types';
export { EmojiPickerService } from './lib/emoji-picker.service';
export { EmojiListComponent, EMOJI_ROW_SIZE } from './lib/emoji-list/emoji-list.component';
export { EmojiComponent } from './lib/emoji/emoji.component';
export { EmojiFallbackHtmlPipe } from './lib/emoji-fallback-html/emoji-fallback-html.pipe';
export { cachedStringSearch } from './lib/helpers';
export { EmojiModule } from './lib/emoji.module';

export { EMOJI_SHORTCODE_MAP, SYMBOL_EMOJI_MAP } from './lib/emoji-datasource';
export { EmojiSupport, EmojiSupportService } from './lib/emoji-support.service';
